module.exports = __webpack_public_path__ + "static/media/BusinessCategory-es.b5f404c1.jpg";